import { createContext } from 'react';

interface CommentsContextProps {
    inactiveOwners: string[] | undefined;
    writeEnabled: boolean;
    confirmDiscardChanges: ((dataTestId?: string) => Promise<boolean>) | undefined;
}

export const CommentsContext = createContext<CommentsContextProps>({
    inactiveOwners: undefined,
    writeEnabled: false,
    confirmDiscardChanges: undefined,
});
